(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lottie-signup-popup"] && !Shopify.designMode) return;
  try {
    
  const startSignup = () => {
  const popup = document.querySelector('[data-ll-signup]');
  if (!popup || popup.dataset.bound === 'true') return;
  popup.dataset.bound = 'true';
  if (popup) {
    const editor = popup.hasAttribute('data-editor');
    const storageKey = 'll-signup-' + popup.id;

    const dismissed = () => {
      if (editor) return false;
      const saved = Number(window.localStorage.getItem(storageKey) || 0);
      if (!saved) return false;
      const days = Number(popup.dataset.days) || 7;
      return Date.now() - saved < days * 86400000;
    };

    const open = () => {
      popup.classList.add('is-open');
      const field = popup.querySelector('input[type="email"]');
      if (field) field.focus();
    };

    const close = () => {
      popup.classList.remove('is-open');
      if (!editor) window.localStorage.setItem(storageKey, String(Date.now()));
    };

    popup.querySelectorAll('[data-ll-signup-close]').forEach((button) => {
      button.addEventListener('click', close);
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && popup.classList.contains('is-open')) close();
    });

    if (popup.querySelector('[data-ll-signup-success]')) {
      open();
      if (!editor) window.localStorage.setItem(storageKey, String(Date.now()));
    } else if (!dismissed()) {
      const narrow = window.matchMedia('(max-width: 700px)').matches;
      if (!(narrow && popup.dataset.mobile !== 'true')) {
        const delay = editor ? 0 : Number(popup.dataset.delay || 0) * 1000;
        window.setTimeout(open, delay);
      }
    }
  }
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startSignup);
  } else {
    startSignup();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
